<template>
  <div class="studentInfo-switch-class">
    <el-dialog
      title="批量切换班级"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      :close-on-click-modal="false"
      width="580px"
      center
    >
      <div>
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <el-form-item label="已选择学生:" label-width="100px">
            <!-- <el-input
              v-model="teacherInfo.teacherName"
              :disabled="true"
              style="width: 200px"
            ></el-input> -->
            <el-tag
              v-for="item in studentSelectList"
              :key="item.id"
              style="margin-right: 4px"
              >{{ item.studentName }}</el-tag
            >
          </el-form-item>
          <el-form-item
            label="选择班级:"
            prop="classNameVal"
            label-width="100px"
          >
            <el-cascader
              v-model="formData.classNameVal"
              :placeholder="classPlaceholder"
              :props="classProps"
              :options="classSelect"
              @change="changeHandle"
            ></el-cascader>
          </el-form-item>
          <el-form-item
            label="选择状态:"
            prop="status"
            label-width="100px"
          >
            <el-select v-model="formData.status" placeholder="请选择">
              <el-option
                v-for="item in studentTypeList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confrim">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  // props: {
  //   dialogVisible: {
  //     type: Boolean,
  //     require: true,
  //   },
  //   studentSelectList: {
  //     type: Array,
  //   },
  // },
  props: [
    "dialogVisible",
    "studentSelectList",
    "classProps",
    "classSelect",
    "classPlaceholder",
    "className",
    "studentTypeList",
  ],
  inject: ["refresh"],
  data() {
    return {
      formData: {
        classNameVal: "",
        status: "",
      },
      rules: {
        classNameVal: [
          { required: true, message: "请选择班级", trigger: "change" },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  methods: {
    // 选择班级
    changeHandle(e) {},
    dialogOpen() {
      this.formData.classNameVal = this.className;
      this.formData.status = "0";
    },
    dialogClose() {
      this.$emit("update:dialogVisible", false);
    },
    confrim() {
      // console.log(this.formData);
      this.$emit("studentSwitchClass", this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentInfo-switch-class.scss";
</style>
